export default __webpack_public_path__ + "static/marintcase1-5ba877b16064461d917a3d700b070bff.png";